//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminUserController_blockUser,
  Response$AdminUserController_blockUser$Status$200,
  ResponseContentType$AdminUserController_blockUser,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminUserController_blockUser = () =>
  useApiClientMutation<
    Params$AdminUserController_blockUser,
    Response$AdminUserController_blockUser$Status$200[ResponseContentType$AdminUserController_blockUser]
  >({ method: 'AdminUserController_blockUser' });
